import * as React from "react";
import { FormControl, InputLabel, LinearProgress, Select } from "@mui/material";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import OutlinedInput from "@mui/material/OutlinedInput";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  ACTUALIZAR_LISTA,
  OPEN_REDUX,
  USER_ERRORSTATE_STATE_CHANGE,
  USER_LOADERROR_STATE_CHANGE,
} from "../../../../redux/constanst";
import Swal from "sweetalert2";
import { hosting } from "../../models/buscar";
import fetchCall from "../../models/fetch.mjs";
import SnakBarAnexos from "../../snakBarAnexos";

export default function AgregarEditarUsuario(props) {
  const { datos, empresa, datos2 } = props;
  const { actualizarLista, openRedux } = useSelector(
    (state) => state.userState
  );
  const [anexos2, setAnexos2] = React.useState(
    datos.anexos === undefined ? [] : datos.anexos
  );
  const [anexosTotales, setAnexosTotales] = React.useState(
    datos.anexos === undefined ? [] : datos.anexos
  );
  const dispatch = useDispatch();
  const levelAcc = empresa ? "empresa" : "sucursal";
  const empresaAsc = !empresa ? datos2.id : null;
  const [open, setOpen] = React.useState(false);
  const [password, setPassword] = React.useState(datos.password);
  const [email, setEmail] = React.useState(datos.email || "");
  const [name, setName] = React.useState(datos.name || "");
  const [rut, setRut] = React.useState(datos.rut || "");
  const [formDisabled, setFormDisabled] = React.useState(false);
  const [anexos, setAnexos] = React.useState([]);

  const verificarAnexo = async (datos) => {
    console.log(datos);
    let extension;
    if (datos.extension) {
      extension = datos.extension;
    } else {
      extension = datos.split(" ")[0];
    }
    const resultado = await fetchCall(
      "salientes_total_select",
      0,
      1,
      0,
      0,
      0,
      0,
      0,
      extension
    );
    return resultado[0] ? true : false;
  };
  const handleChange = async (event, children) => {
    event.preventDefault();
    const {
      target: { value },
    } = event;
    if (
      anexos2.length > value.length &&
      !anexos.find(
        (data) => data.extension === children.props.value.extension
      )
    ) {
      const verificar = await verificarAnexo(
        children.props.value.extension
      );
      if (verificar) {
        
        setOpen(true);
        return;
      } else {
        setAnexos2(
          // On autofill we get a stringified value.
          typeof value === "string" ? value.split(",") : value
        );
      }
    } else {
      console.log(anexos2)
      if(anexos2.find(
        (data) => data.extension === children.props.value.extension
      )){
          const indice = anexos2.filter((data) => data.extension !== children.props.value.extension)
          setAnexos2(indice)

      }else{
       
        setAnexos2([...anexos2, children.props.value]);
      }
      
    }
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };
  useEffect(() => {
    axios
      .get(`${hosting}/mimegacall/api/select_anexos.php`)
      .then((response) => {
        const arrAnexo2 = [];
        arrAnexo2.push(anexos2);
        arrAnexo2.push(Object.values(response.data));
        setAnexos(Object.values(response.data));
      })
      .catch(function (error) {
        console.log(error);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const enviar = async (data) => {
    setFormDisabled(true);
    const anexosEnviar = anexos2.map((data) =>{
      return `${data.extension} ${data.name}` 
    })
    axios
      .get(
        `${hosting}/mimegacall/api/update_usuario.php?id=${datos.id}&anexos=${anexosEnviar}&name=${name}&password=${password}&email=${email}&levelAcc=${levelAcc}&idAsoc=${empresaAsc}&rut=${rut}`
      )
      .then((response) => {
        dispatch({ type: ACTUALIZAR_LISTA, actualizarLista: !actualizarLista });
        Swal.fire(response.data.mensaje, ``, response.data.type).then(
          (result) => {
            dispatch({
              type: ACTUALIZAR_LISTA,
              actualizarLista: !actualizarLista,
            });
          }
        );
        dispatch({ type: OPEN_REDUX, openRedux: !openRedux });
        setFormDisabled(false);
      })
      .catch(function (error) {
        console.log(error);
      });

    data.preventDefault();
  };
  return (
    <>
      <Paper sx={{ margin: "auto", overflow: "hidden" }}>
        <form onSubmit={(e) => enviar(e)}>
          <Grid
            style={{ padding: "20px" }}
            container
            spacing={0}
            alignItems="center"
          >
            <Grid item xs={12}>
              <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
                <TextField
                  id="name"
                  label="Nombre completo"
                  defaultValue={datos.name}
                  onChange={(e) => {
                    setName(e.target.value);
                  }}
                  disabled={formDisabled}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12}>
              <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
                <TextField
                  id="rut"
                  label=" Rut"
                  defaultValue={datos.rut}
                  onChange={(e) => {
                    setRut(e.target.value);
                  }}
                  disabled={formDisabled}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl sx={{ m: 1, width: "99%" }} variant="outlined">
                <TextField
                  id="email"
                  type={"email"}
                  label="Email"
                  defaultValue={datos.email}
                  on
                  onLoad={(e) => {
                    setEmail(e.target.value);
                  }}
                  onChange={(e) => {
                    setEmail(e.target.value);
                  }}
                  disabled={formDisabled}
                />
              </FormControl>
            </Grid>
            <Grid item xs={12} md={12}>
              <FormControl sx={{ m: 1, width: "99%" }} variant="outlined">
                <TextField
                  id="password"
                  type={"password"}
                  label="Contraseña"
                  defaultValue={datos.password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                  }}
                  disabled={formDisabled}
                />
              </FormControl>
            </Grid>

            {!empresa ? (
              <Grid item xs={12}>
                <FormControl
                  sx={{ m: 1, width: "100%", maxWidth: 850 }}
                  variant="outlined"
                >
                  <InputLabel id="demo-multiple-checkbox-label">
                    Anexos
                  </InputLabel>
                  <Select
                    sx={12}
                    labelId="demo-multiple-checkbox-label"
                    id="demo-multiple-checkbox"
                    multiple
                    setFormDisabled
                    value={anexos2}
                    onChange={handleChange}
                    input={<OutlinedInput label="Anexos" />}
                    renderValue={(selected) => {
                      const seleted2 = selected.map((data) => {
                        return `${data.extension} ${data.name}`;
                      });
                      return seleted2.join(", ");
                    }}
                    MenuProps={MenuProps}
                    disabled={formDisabled}
                  >
                    {anexosTotales.concat(anexos).map((data) => {
                      return data.name !== "ALL" ? (
                        <MenuItem
                         className={anexos2.find(
                          (data2) => data2.extension === data.extension
                        )
                          ? 'Mui-selected'
                          : false}
                          /*  onClick={(e)=> verificarAnexo(data)} */
                          disabled={data.status === "0"}
                          key={`${data.extension} ${data.name}`}
                          value={data}
                        >
                          <Checkbox
                            checked={
                              anexos2.find(
                                (data2) => data2.extension === data.extension
                              )
                                ? true
                                : false
                            }
                          />
                          <ListItemText
                            primary={`${data.extension} ${data.name}`}
                          />
                        </MenuItem>
                      ) : null;
                    })}
                  </Select>
                </FormControl>
              </Grid>
            ) : null}

            <Grid item xs={12}>
              <FormControl sx={{ m: 1, width: "99.5%" }} variant="outlined">
                {!formDisabled ? (
                  <Button
                    type="submit"
                    variant="contained"
                    sx={{ mr: 1 }}
                    disabled={formDisabled}
                  >
                    Guardar
                  </Button>
                ) : (
                  <LinearProgress />
                )}
              </FormControl>
            </Grid>
          </Grid>
        </form>
      </Paper>
      <SnakBarAnexos
        open={open}
        setOpen={setOpen}
        alertText={"Este Anexo contiene llamadas tarifadas"}
      />
    </>
  );
}
